import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");

    if (!consent) {
      setShow(true);
    }
  }, []);

  function acceptCookies() {
    localStorage.setItem("cookieConsent", "accepted");
    setShow(false);
  }

  function refuseCookies() {
    localStorage.setItem("cookieConsent", "refused");
    setShow(false);
  }

  return (
  <AnimatePresence>
    {show && (
      <>
        {/* ================= DESKTOP ================= */}
        <motion.div
          initial={{ opacity: 0, y: 120 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 120 }}
          transition={{ duration: 0.35 }}
          className="hidden md:block fixed bottom-5 left-1/2 -translate-x-1/2 z-[9999] w-[95%] max-w-xl"
        >
          <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 p-6">
            <div className="flex gap-4">
              <div className="bg-blue-100 w-14 h-14 rounded-full flex items-center justify-center flex-shrink-0">
                <Cookie className="text-blue-600" size={28} />
              </div>

              <div className="flex-1">
                <h2 className="font-bold text-lg text-gray-800">
                  Cookies
                </h2>

                <p className="text-sm text-gray-600 mt-2 leading-relaxed">
                  Nous utilisons des cookies afin d'améliorer votre
                  expérience, sécuriser votre connexion et analyser
                  les performances de notre site.
                </p>

                <Link
                  to="/cookies"
                  target="_blank"
                  className="inline-block mt-3 text-blue-600 hover:underline text-sm font-semibold"
                >
                  En savoir plus →
                </Link>

                <div className="flex flex-wrap gap-3 mt-5">
                  <button
                    onClick={refuseCookies}
                    className="px-5 py-2 rounded-xl border border-gray-300 hover:bg-gray-100 transition"
                  >
                    Refuser
                  </button>

                  <button
                    onClick={acceptCookies}
                    className="px-5 py-2 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold transition"
                  >
                    Accepter
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* ================= MOBILE ================= */}
        <motion.div
          initial={{ y: "100%" }}
          animate={{ y: 0 }}
          exit={{ y: "100%" }}
          transition={{
            duration: 0.35,
            ease: "easeOut",
          }}
          className="md:hidden fixed bottom-0 left-0 right-0 z-[9999]"
        >
          <div className="bg-white rounded-t-3xl shadow-[0_-10px_30px_rgba(0,0,0,0.18)] px-5 pt-5 pb-7">

            <div className="w-12 h-1.5 bg-gray-300 rounded-full mx-auto mb-4" />

            <div className="flex items-center gap-3">
              <div className="bg-blue-100 w-12 h-12 rounded-full flex items-center justify-center">
                <Cookie className="text-blue-600" size={22} />
              </div>

              <div>
                <h2 className="font-bold text-gray-800">
                  Cookies
                </h2>

                <p className="text-xs text-gray-500">
                  Votre confidentialité est importante.
                </p>
              </div>
            </div>

            <p className="text-sm text-gray-600 mt-4 leading-relaxed">
              Nous utilisons des cookies pour améliorer votre expérience,
              sécuriser votre connexion et analyser les performances du site.
            </p>

            <Link
              to="/cookies"
              target="_blank"
              className="inline-block mt-3 text-blue-600 text-sm font-semibold"
            >
              En savoir plus →
            </Link>

            <div className="grid grid-cols-2 gap-3 mt-5">
              <button
                onClick={refuseCookies}
                className="py-3 rounded-xl border border-gray-300 font-medium"
              >
                Refuser
              </button>

              <button
                onClick={acceptCookies}
                className="py-3 rounded-xl bg-blue-600 text-white font-semibold"
              >
                Accepter
              </button>
            </div>
          </div>
        </motion.div>
      </>
    )}
  </AnimatePresence>
);
}